import React from "react";
import Page from "@jumbo/shared/Page";
import OrderTracking from "app/pages/order_tracking/OrderTracking";
import ConfirmInvitation from "app/pages/users/ConfirmInvitation";

const publicRoutes = [
    {
        path: "/order_tracking/:trackingId",
        element: <Page component={OrderTracking} layout="solo-page" />
    },
    {
        path: "/confirm_invitation/:token",
        element: <Page component={ConfirmInvitation} layout="solo-page" />
    },
];

export default publicRoutes;